import type { RequestConfig } from '@patsnap/common-ps-http'
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import psHttp from '@patsnap/common-ps-http';
import _ from 'lodash'
import type { AxiosError } from 'axios';

export interface PsHttpServiceOptions {
    headers?: Record<string, string>;
    baseURL?: string;
}

@injectable()
export abstract class DiscoveryHttpService {
    abstract readonly options: PsHttpServiceOptions;
    httpClient: typeof psHttp = psHttp

    request<T>(config: RequestConfig): Promise<T> {
        config.headers = _.merge({}, this.options.headers, config.headers)
        config.baseURL = config.baseURL || this.options.baseURL
        return this.httpClient<T>(config)
            .then(data => {
                return data.data;
            })
            .catch((error: AxiosError) => {
                throw error
            })
    }

    get<T>(config: RequestConfig): Promise<T> {
        config = _.merge({
            method: 'get',
        }, config)
        return this.request<T>(config)
    }

    post<T>(config: RequestConfig): Promise<T> {
        config = _.merge({
            method: 'post',
        }, config)
        return this.request<T>(config)
    }

    put<T>(config: RequestConfig): Promise<T> {
        config = _.merge({
            method: 'put',
        }, config)
        return this.request<T>(config)
    }

    patch<T>(config: RequestConfig): Promise<T> {
        config = _.merge({
            method: 'patch',
        }, config)
        return this.request<T>(config)
    }

    delete<T>(config: RequestConfig): Promise<T> {
        config = _.merge({
            method: 'delete',
        }, config)
        return this.request<T>(config)
    }

    postForm<T>(config: RequestConfig): Promise<T> {
        config = _.merge({
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
        }, config)
        return this.request<T>(config)
    }

    postMultipartForm<T>(config: RequestConfig): Promise<T> {
        config = _.merge({
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }, config)
        return this.request<T>(config)
    }

    patchMultipartForm<T>(config: RequestConfig): Promise<T> {
        config = _.merge({
            method: 'patch',
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }, config)
        return this.request<T>(config)
    }
}
